import type { RefObject } from 'react';
import { useCallback } from 'react';

import type { SortInput } from '@zen/types';

interface UseTableSortProps {
  onOrderChange?: (order: SortInput) => void;
  setPageScroll: (scroll: number) => void;
  tableContentRef: RefObject<HTMLDivElement | null>;
}

interface UseTableSortReturn {
  handleOrderChange: (newOrder: SortInput) => void;
}

export const useTableSort = ({ onOrderChange, tableContentRef, setPageScroll }: UseTableSortProps): UseTableSortReturn => {
  const handleOrderChange = useCallback(
    (newOrder: SortInput) => {
      const wrap = tableContentRef.current;
      const tableScrollPosition = Number(wrap?.scrollLeft) || 0;

      setPageScroll(tableScrollPosition);

      if (onOrderChange && newOrder) {
        setTimeout(() => {
          onOrderChange(newOrder);
        }, 0);
      }
    },
    [setPageScroll, onOrderChange, tableContentRef]
  );

  return {
    handleOrderChange
  };
};
